var React = require('react');

function File1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"file-1","transform":"translate(-0.004)"},React.createElement("path",{"id":"Shape","d":"M14.79,24H1.1A1.1,1.1,0,0,1,0,22.9V3.951a1.1,1.1,0,0,1,1.1-1.1H2.853V1.539A1.541,1.541,0,0,1,4.392,0H17.2a1.541,1.541,0,0,1,1.539,1.539V19.608A1.541,1.541,0,0,1,17.2,21.147H15.888V22.9A1.1,1.1,0,0,1,14.79,24ZM1.108,3.961V22.892H14.78V8.809H11.186A1.256,1.256,0,0,1,9.932,7.555V3.961ZM4.392,1.108a.432.432,0,0,0-.431.431V2.853h6.525a.549.549,0,0,1,.391.162l4.849,4.848a.553.553,0,0,1,.161.379.057.057,0,0,0,0,.006.054.054,0,0,1,0,.006V20.038H17.2a.431.431,0,0,0,.43-.43V1.539a.431.431,0,0,0-.43-.431ZM11.04,4.745V7.556a.146.146,0,0,0,.146.146H14Z","transform":"translate(0.004)","fill":"#DE375C"})));
}

File1.defaultProps = {"width":"18.742","height":"24","viewBox":"0 0 18.742 24"};

module.exports = File1;

File1.default = File1;
